import React from "react";
import { C } from "../theme";

export default function ScoreRing({ value, size = 90, color = C.accent }) {
  const r = size / 2 - 8;
  const circ = 2 * Math.PI * r;
  const pct = (value / 100) * circ;
  return (
    <div style={{ position: "relative", width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
              <circle
                cx={size / 2}
                cy={size / 2}
                r={r}
                fill="none"
                stroke={C.border}
                strokeWidth={6}
              />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={6}
          strokeDasharray={`${pct} ${circ}`}
          strokeLinecap="round"
          style={{ transition: "stroke-dasharray 1s ease" }}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span
          style={{
            fontSize: size * 0.28,
            fontWeight: 800,
            color,
            fontFamily: "Georgia,serif",
            lineHeight: 1,
          }}
        >
          {value}
        </span>
        <span
          style={{
            fontSize: 7,
            color: C.muted,
            letterSpacing: 1.5,
            marginTop: 2,
          }}
        >
          PREP
        </span>
      </div>
    </div>
  );
}
